import classNames from 'classnames/bind';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  checked: boolean;
  clickCode: string;
  label?: string;
  value: string;
  onChange(): void;
}

export default function Airport({
  checked,
  clickCode,
  label,
  value,
  onChange,
}: IProps) {
  if (!label) {
    return null;
  }

  return (
    <button
      aria-checked={checked}
      className={cx('checkbox')}
      role="checkbox"
      type="button"
      data-event-nlog="click"
      data-event-area-code={clickCode}
      onClick={onChange}
    >
      <span className={cx('name')}>
        <span className={cx('namekr')}>{label}</span>
        <span className={cx('code')}>{value}</span>
      </span>
    </button>
  );
}
